import React from "react";

import Footer from "../footer";
import Header from "../darkhome/Header";

import "../style/consultancy.module.css";
import ConsultancyForm from "./components/consultancy-form";

const Points = {
    what: [
        "Evaluate build vs buy",
        "Building RBAC and other features",
        "Which provider to use for your specific use case",
        "Migrating from one identity provider to another(or your own)",
        "Sessions, cookies, JWTs, iframes, localstorage, CSRF,multiple api domains etc",
        "Issues with implementation details (eg: issues withmultiple sub domains & multi tenancy, SAMLintegrations, customizing existing solution)",
        "Anything related to authN or AuthZ infrastructure"
    ]
};

export default function ContactSales() {
    return (
        <div className="consultancy__container">
            <Header />
            <div className="consultancy__inner__container">
                <section className="top__section padding-x">
                    <div>
                        <div className="pill">
                            <span>For companies of all sizes</span>
                        </div>
                        <h1 className="consultancy__heading">
                            Talk to our sales team about your requirements, learn about custom pricing, or <span>request a
                            demo.</span>
                        </h1>
                    </div>
                </section>
                <hr className="green__gradient top__section__hr" />
                <section className="mid__section padding-x">
                    <h2 className="consultancy__seconday__title">Here is what we can help you with:</h2>
                    <div className="bullet__points__container green__border">
                        <ul>
                            {Points.what.map(point => (
                                <li key={point.substring(0, 5)}>
                                    <img src="/static/assets/consultancy/check-box.svg" alt="checkbox" />
                                    {point}
                                </li>
                            ))}
                        </ul>
                    </div>
                </section>

                <ConsultancyForm visibilityClass="hidden__lg" containerClass="end__section padding-x" />
                <ConsultancyForm visibilityClass="hidden__md" containerClass="absoulte__container hidden__md" />
            </div>
            <Footer />
        </div>
    );
}
